import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { respondTo } from "@animech/ui";

export const Label = styled.span``;
export const Toggle = styled.a``;
export const Content = styled.div``;
export const Panel = styled.div``;

export const AccordionRoot = styled.div<{ open: boolean }>`
	${({ theme, open }) => {
		return css`
			display: flex;
			flex-direction: column;
			min-height: 0;
			flex: 0 0 auto;
			max-height: none;

			${open &&
			css`
				max-height: fit-content;
				flex: 1 1 0%;
			`}

			${Toggle}, ${Toggle} {
				text-decoration: none;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: ${theme.dimensions.margin.base} 0;

				:hover {
					svg {
						scale: 1.2;
					}
				}

				${Label} {
					color: ${theme.colors.foregrounds[1]};
					font-size: ${theme.typography.fontSize.xxLarge};
					font-weight: ${theme.typography.fontWeight.light};
					font-family: ${theme.typography.fontFamily.primary};
				}

				${respondTo(theme, "mobile")} {
					min-height: ${theme.app.mobile.minTouchTarget};
					padding: ${theme.dimensions.margin.small} 0;
				}
			}

			${Panel} {
				display: grid;
				grid-template-rows: ${open ? "1fr" : "0fr"};
				transition: ${open ? "250ms ease-in-out" : "none"};
				opacity: ${open ? 1 : 0};
				overflow: hidden;
			}
			${Content} {
				min-height: 0px;
				overflow: auto;
				scrollbar-gutter: stable;
			}

			${Content} {
				min-height: 0;
				overflow: ${open ? "auto" : "hidden"};
				padding-right: ${theme.dimensions.margin.small};
				scrollbar-gutter: stable;
			}
		`;
	}}
`;
